"use client";

import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "~/lib/utils";

const base_style = "relative z-20 rounded-l-sm inline-block px-4 py-3.5 hover:bg-slate-900";
const default_style = "border-r-2 border-gray-700";
const active_style = "border-r-4 border-sky-400 translate-x-0.25";

interface LinkProps {
  href: string;
  label: string;
}

export default function Link({ href, label }: LinkProps) {
  const pathname = usePathname();
  const isActive = pathname === href;
  return (
    <NextLink dir="auto" className={cn(base_style, isActive ? active_style : default_style)} href={href}>
      {label}
    </NextLink>
  );
}
